import styled from 'styled-components';
import color from '../../constants/color';
import materialUI from '../../material-UI';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Row: any = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
`;
export const Img: any = styled.img`
  height: 16px;
  margin-right: 9.85px;
  margin-left: 16px;
`;
export const Text: any = styled.div`
  height: 16px;
  font-size: 0.875rem;
  color: ${color.Black};
  font-family: Inter;
  font-weight: 600px;
  text-transform: inherit;
`;
export const Avatar = styled(materialUI.Avatar)`
  margin-right: 10px;
`;
export const Divider = styled.div`
  display: flex;
  flex-direction: row;
  height: 1px;
  background-color: ${color.Lightgrey};
  margin-top: 10px;
  margin-bottom: 10px;
`;
